// vendor modules
import styled from 'styled-components'

export const ModalContainer = styled.div`
  color: ${props => (props.theme.color.button.primary)};
  font-family: 'Montserrat', sans-serif;
  height: 90%;
  padding: 0 2rem;
`
